import Vue from "vue";

export const Agent = {
  methods: {
    //TODO: 获取侧边栏图标信息
    async getAgent(vm) {
        let that = vm || this;

        let res = await that.$http.get(`/tenant/home/todo`);
        if(res?.data?.info?.length > 0){
           that.$store.commit('upAgent_info', res.data);//存到vuex,更新客资信息
        }
        console.log(res,'侧边栏信息');
        return res.data ?? {};
      },
  },
};
